import { render, staticRenderFns } from "./005_Betonsarkophag.vue?vue&type=template&id=6dca2497&scoped=true&"
import script from "./005_Betonsarkophag.vue?vue&type=script&lang=js&"
export * from "./005_Betonsarkophag.vue?vue&type=script&lang=js&"
import style0 from "./005_Betonsarkophag.vue?vue&type=style&index=0&id=6dca2497&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dca2497",
  null
  
)

export default component.exports